import { forwardRef } from 'react';

// Este componente é renderizado fora da tela e capturado como imagem
// Proporção 9:16 para Instagram Stories
const DetoxShareCard = forwardRef(function DetoxShareCard({ enrollment, checkins }, ref) {
  const daysStayedOff = checkins.filter(c => c.stayed_off).length;
  const totalReflections = checkins.filter(c => c.reflection?.trim()).length;
  const initial = enrollment?.initial_screen_time || '?';
  const final   = enrollment?.final_screen_time   || '?';

  const changed = initial !== final && enrollment?.final_screen_time;

  return (
    <div ref={ref} className="share-card">
      {/* Background gradient blobs */}
      <div className="share-blob share-blob-1" />
      <div className="share-blob share-blob-2" />

      {/* Header */}
      <div className="share-header">
        <span className="share-logo-emoji">📓</span>
        <span className="share-logo-text">Clube do Eu</span>
      </div>

      {/* Badge */}
      <div className="share-badge">
        <span className="share-badge-emoji">🧘</span>
        <div>
          <p className="share-badge-title">Mente Livre</p>
          <p className="share-badge-sub">Conquista desbloqueada</p>
        </div>
      </div>

      {/* Title */}
      <div className="share-title-block">
        <p className="share-challenge-label">DESAFIO COMPLETO</p>
        <h2 className="share-challenge-title">7 Dias de<br />Detox Digital</h2>
      </div>

      {/* Before / After */}
      <div className="share-before-after">
        <div className="share-ba-col">
          <p className="share-ba-label">📱 Antes</p>
          <p className="share-ba-value">{initial}</p>
          <p className="share-ba-sub">nas redes/dia</p>
        </div>
        <div className="share-ba-arrow">→</div>
        <div className="share-ba-col share-ba-highlight">
          <p className="share-ba-label">✨ Depois</p>
          <p className="share-ba-value">{final}</p>
          <p className="share-ba-sub">nas redes/dia</p>
        </div>
      </div>

      {/* Stats row */}
      <div className="share-stats">
        <div className="share-stat">
          <span className="share-stat-num">{daysStayedOff}</span>
          <span className="share-stat-label">dias sem{'\n'}redes 📵</span>
        </div>
        <div className="share-stat-divider" />
        <div className="share-stat">
          <span className="share-stat-num">7</span>
          <span className="share-stat-label">dias de{'\n'}escrita ✍️</span>
        </div>
        <div className="share-stat-divider" />
        <div className="share-stat">
          <span className="share-stat-num">{totalReflections}</span>
          <span className="share-stat-label">reflexões{'\n'}escritas 📝</span>
        </div>
      </div>

      {/* Message */}
      <p className="share-message">
        {changed
          ? `Ganhei tempo de volta para o que importa.`
          : `Sete dias para descobrir quem sou sem o feed.`}
      </p>

      {/* Footer */}
      <div className="share-footer">
        <p className="share-footer-url">clubedoeu.com.br</p>
        <p className="share-footer-cta">Faça o seu detox também →</p>
      </div>
    </div>
  );
});

export default DetoxShareCard;
